/**
 * Manifest source colors as raw hexes — a zero-dependency leaf module (no MUI,
 * Apollo, or graphql imports) so both the M2 drawer (`manifestSourceDisplay.ts`)
 * and the M3 compare dialog (`CompareSourcesDialog.helpers.ts`, which must stay
 * unit-testable without pulling in Apollo/MUI) can share ONE definition instead
 * of hand-syncing the values across the M2/M3 boundary.
 *
 * Values are MUI palette accents (noted inline) — inlined as hexes here so this
 * file keeps zero imports.
 */

/** Per-field source DOT colors — the bright/neon accent of each source's hue. */
export const SOURCE_DOT_HEX = {
  eManifest: "#00c853", // MUI green.A700
  vendor: "#00b0ff", // MUI lightBlue.A400
  document: "#3d5afe", // MUI indigo.A400
} as const;

/** The "Document" Data Sources chip color — darker, legible as a chip label. */
export const DOCUMENT_CHIP_HEX = "#3f51b5"; // MUI indigo[500]
